import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import modules from './modules'

Vue.use(Vuex)

const strict = process.env.NODE_ENV !== 'production'

const plugins = [
    createPersistedState({
        key: 'op_forecasting_topojsons_v1.63',
        paths: ['geojson', 'persistentUx']
    })
]

const store = new Vuex.Store({
    modules,
    strict,
    plugins
})

export default store
